import { EXERCISES_PATH } from '../constants/path'
import getByIdExerciseSelector from './get-by-id'
import {
  MEDIA_MODEL_KEY,
  MEDIA_MODEL_TYPE
} from '../../../media'
import getCurrentReduxSelector from '../../../redux/selectors/get-current'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../redux/utils/get-instance'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import { createSelector } from 'reselect'
import { EXERCISE_KEY } from '../../model'

export const getCurrentExerciseSelect = getCurrentReduxSelector(
  EXERCISES_PATH.DATA,
  EXERCISES_PATH.CURRENT
)

const getMediaExerciseSelect = (exercise) => state => {
  const mediaPointers = getValueReduxUtil(exercise, EXERCISE_KEY.MEDIA) || []
  return mediaPointers.map(pointer => getInstanceReduxUtil(state, pointer))
}
export const getCurrentExerciseMediaSelect = state => {
  const currentExercise = getCurrentExerciseSelect(state)
  return getMediaExerciseSelect(currentExercise)(state)
}

function getSingleMediaVideo (media) {
  return media.find(item => getValueReduxUtil(item, MEDIA_MODEL_KEY.TYPE) ===
    MEDIA_MODEL_TYPE.VIDEO)
}

function getSingleMediaImage (media) {
  return media.find(item => getValueReduxUtil(item, MEDIA_MODEL_KEY.TYPE) ===
    MEDIA_MODEL_TYPE.IMAGE)
}

export const getCurrentExerciseMediaVideo = createSelector(getCurrentExerciseMediaSelect,
  media => {
    return getSingleMediaVideo(media)
  }
)

export const getVideoMediaIdByExerciseIdSelector = id => state => {
  const exercise = getByIdExerciseSelector(id)(state)
  return getIdReduxUtil(getSingleMediaVideo(getMediaExerciseSelect(exercise)(
    state)))
}

export const getImageMediaIdByExerciseIdSelector = id => state => {
  const exercise = getByIdExerciseSelector(id)(state)
  return getIdReduxUtil(getSingleMediaImage(getMediaExerciseSelect(exercise)(
    state)))
}

export const getCurrentExerciseMediaImage = createSelector(getCurrentExerciseMediaSelect,
  media => getSingleMediaImage(media)
)

export const getByIdExerciseMediaImageIdSelector = createSelector(getCurrentExerciseMediaImage,
  media => getIdReduxUtil(media)
)

export {
  default as getFoundExercisesSelector
} from './get-found'

export {
  default as getByIdExerciseSelector
} from './get-by-id'
